
import { cn } from "@/lib/utils";
import { getRpgThemeClasses } from "@/lib/utils";

interface SettingsFooterProps {
  enableRpgMode: boolean;
  darkMode: boolean;
}

const SettingsFooter: React.FC<SettingsFooterProps> = ({ enableRpgMode, darkMode }) => {
  const rpgTheme = getRpgThemeClasses(enableRpgMode, darkMode);

  return (
    <footer className={cn(
      "mt-8 text-center text-sm",
      enableRpgMode ? rpgTheme.accent : (darkMode ? "text-[#D896A4]" : "text-[#003F6B]")
    )}>
      <p className={enableRpgMode ? "drop-shadow-sm" : ""}>
        {enableRpgMode 
          ? "Unstuck: An ancient tool to break down barriers and forge new paths of adventure."
          : "Unstuck: A magic tool to break down walls and build new journeys."
        }
      </p>
      <p className={cn(
        "mt-1",
        enableRpgMode ? rpgTheme.accent : (darkMode ? "text-[#D896A4]" : "text-[#003F6B]")
      )}>
        Built with ❤️ by <a 
          href="https://ameliastewart.co" 
          target="_blank" 
          rel="noopener noreferrer"
          className={cn(
            "hover:underline transition-colors",
            enableRpgMode ? "text-amber-500 hover:text-amber-400" : (
              darkMode ? "text-[#AE78F0] hover:text-[#c096ff]" : "text-[#6127A0] hover:text-[#4d1f80]"
            )
          )}
        >
          Amelia Stewart
        </a>
      </p>
    </footer>
  );
};

export default SettingsFooter;
